// extracted by mini-css-extract-plugin
export var badge = "_wh-4";
export var selected = "_wh-1";
export var selectedOverlay = "_wh-5";
export var thumbnailButton = "_wh-0";
export var thumbnailFallback = "_wh-3";
export var thumbnailImage = "_wh-2";